import { useMemo } from 'react';
import { buildZoneMap } from 'utils/seatPricing';
import { resolveSeatPriceZonesForTripZoneMap } from 'utils/purchasePricingSeatZones';

/**
 * Build zone map for purchase pricing trip (checkout / pre-checkout seat-based UI).
 * @param {object} params - Hook parameters.
 * @param {object} params.purchase - Full purchase state (plain).
 * @param {string} params.way - Trip leg key (`departs` or `returns`).
 * @param {object} params.reservation - Reservation object for this leg.
 * @param {object} params.seatsBus - seatsBus state map (plain).
 * @param {string} params.tripSlug - Trip slug for seatsBus lookup.
 * @param {Array<Object>} [params.selectedSeatsBeforeCheckout] - Pre-checkout selected seats fallback.
 * @returns {{ zoneMap: object, seatPriceZonesForZoneMap: Array<Object> }}
 */
const usePurchasePricingSeatZones = ({
  purchase = {},
  way,
  reservation = {},
  seatsBus = {},
  tripSlug,
  selectedSeatsBeforeCheckout,
}) => {
  return useMemo(() => {
    const purchaseLeg = purchase?.[way] || {};
    const seatPriceZonesForZoneMap = resolveSeatPriceZonesForTripZoneMap({
      purchaseLeg,
      reservation,
      seatsBus,
      tripSlug,
      selectedSeatsBeforeCheckout,
    });
    const zoneMap = buildZoneMap({ seatPriceZones: seatPriceZonesForZoneMap });
    return { zoneMap, seatPriceZonesForZoneMap };
  }, [purchase, way, reservation, seatsBus, tripSlug, selectedSeatsBeforeCheckout]);
};

export default usePurchasePricingSeatZones;
